export default __webpack_public_path__ + "static/media/uk-flag.4be13176.svg";